import { createSlice } from "@reduxjs/toolkit";

// Status
const ActiveStatus = [
  { label: "Active", value: true },
  { label: "Inactive", value: false },
];

const TrueOrFalse = [
  { value: true, label: "True" },
  { value: false, label: "False" },
];

const ButtonTarget = [
  { value: "_self", label: "Current Tab" },
  { value: "_blank", label: "New Tab" },
];

const statusOptions = [
  { value: 1, label: "Yes" },
  { value: 0, label: "No" },
];

const eventType = [
  { value: "single", label: "Single" },
  { value: "recurrence", label: "Recurrence" },
];

const locationType = [
  { value: "virtual", label: "Virtual" },
  { value: "physical", label: "In-Person" },
  { value: "hybrid", label: "Hybrid" },
];

const numberSet = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
];


const monthFrequencySet = [
  { value: 1, label: "First-Week" },
  { value: 2, label: "Second-Week" },
  { value: 3, label: "Third-Week" },
  { value: 4, label: "Fourth-Week" },
  { value: 5, label: "Last-Week" },
];

const periodSet = [
  { value: "day", label: "Day" },
  { value: "week", label: "Week" },
  { value: "month", label: "Month" },
  { value: "year", label: "Year" },
];
const daySet = [
  { value: "sunday", label: "Sunday" },
  { value: "monday", label: "Monday" },
  { value: "tuesday", label: "Tuesday" },
  { value: "wednesday", label: "Wednesday" },
  { value: "thursday", label: "Thursday" },
  { value: "friday", label: "Friday" },
  { value: "saturday", label: "Saturday" },
];

const authendication = [
  { value: "email", label: "Email" },
  { value: "mfa", label: "Google Authenticator" },
];

//
const routeOptions = [
  { value: "internal", label: "Internal" },
  { value: "external", label: "External" },
];

// Text Editor Options
const editorColumn = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
];

// const ColTwoAlginments = [
//   { value: "Left-4", label: "Left-4" },
//   { value: "Left-6", label: "Left-6" },
//   { value: "Right-4", label: "Right-4" },
//   { value: "Right-6", label: "Right-6" },
// ];

const ColTwoAlginments = [
  { value: "left-4", label: "LeftWide-4" },
  { value: "left-6", label: "LeftWide-6" },
  { value: "right-4", label: "RightWide-4" },
  { value: "right-6", label: "RightWide-6" },
  { value: "right-6-container", label: "RightWide-6-Container" },
  { value: "left-6-container", label: "LeftWide-6-Container" },
  // { value: "EqualSplit-6-6", label: "Equal Split (6-6)" },
];

// const LayoutOptions = [
//   { value: "EqualSplit", label: "Equal Split (50% - 50%)" },
//   { value: "LeftWide", label: "Left Wide (66% - 33%)" },
//   { value: "RightWide", label: "Right Wide (33% - 66%)" },
// ];

const ColThreeAlginments = [
  { value: "left", label: "Left" },
  { value: "right", label: "Right" },
  { value: "center", label: "Center" },
];

// create slice
const name = "dropdowns"; // Generalized name for dropdown management
const initialState = createInitialState();

const slice = createSlice({
  name,
  initialState,
  reducers: {},
});

// exports
export const dropdownActions = {
  ...slice.actions,
};
export const dropdownReducer = slice.reducer;

// implementation
function createInitialState() {
  return {
    ActiveStatus: ActiveStatus,
    TrueOrFalse: TrueOrFalse,
    ButtonTarget: ButtonTarget,
    statusOptions: statusOptions,
    eventType: eventType,
    locationType: locationType,
    numberSet: numberSet,
    monthFrequencySet:monthFrequencySet,
    periodSet: periodSet,
    daySet: daySet,
    authendication: authendication,
    routeOptions: routeOptions,
    ColTwoAlginments: ColTwoAlginments,
    ColThreeAlginments: ColThreeAlginments,
    editorColumn: editorColumn,
  };
}
